export const isIos = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export function isIOSSafari() {
  const ua = window.navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
}
